var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTagUser = function SvgIconTagUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M30 31.434h-1.267a4.98 4.98 0 0 0-3.533 1.45L22.35 35.7a3.37 3.37 0 0 1-4.717 0l-2.85-2.817a5 5 0 0 0-3.533-1.45H10c-2.767 0-5-2.216-5-4.95v-18.2c0-2.733 2.233-4.95 5-4.95h20c2.767 0 5 2.217 5 4.95v18.184c0 2.733-2.233 4.967-5 4.967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.117 14.917h-.25a3.24 3.24 0 0 1-3.134-3.25c0-1.8 1.45-3.25 3.25-3.25s3.25 1.466 3.25 3.25a3.206 3.206 0 0 1-3.116 3.25M15.417 19.933c-2.217 1.483-2.217 3.9 0 5.383 2.517 1.684 6.65 1.684 9.167 0 2.216-1.483 2.216-3.9 0-5.383-2.517-1.667-6.634-1.667-9.167 0"
  }))));
};
export default SvgIconTagUser;